import { render, staticRenderFns } from "./GalleryComponentCard.vue?vue&type=template&id=6ca35817&scoped=true"
import script from "./GalleryComponentCard.vue?vue&type=script&lang=js"
export * from "./GalleryComponentCard.vue?vue&type=script&lang=js"
import style0 from "./GalleryComponentCard.vue?vue&type=style&index=0&id=6ca35817&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca35817",
  null
  
)

export default component.exports